import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import { FormatResponse } from "../../util/string-helper";

const PreformattedTextContainer = ({ props, height, width }) => {
  const processMarkdown = (markdown) => {
    if (markdown === undefined) {
      return ''; // Return an empty string when markdown is undefined
    }

    if ((!markdown || typeof markdown !== 'string') && markdown != "") {
      return markdown.toString(); // Return the original value of `markdown` if it is not a string or is empty
    }
    
    if (markdown.match(/(^Job Description: (.+)|Job Description:\s*(.+)|Role:|Responsibilities:|Results:|Requirements:)/gm)) {
      markdown = markdown.replace(/(Job Description:\s*(.+)|Role:|Responsibilities:|Results:|Requirements:)/gm, "**$1**");
    }
    
    return markdown;
  };

  return (
    // <div className={`${height ? height : "h-[34rem]"} ${width ? width : ""} w-full  overflow-hidden select-none`}>
    //   <ReactMarkdown
    //     children={processMarkdown(props)}
    //     remarkPlugins={[remarkGfm, remarkBreaks]}
    //   />
    // </div>
    <pre style={{whiteSpace: "pre-wrap", fontFamily: "inherit"}} className={`${height ? height : "h-[34rem]"} ${width ? width : ""} w-full  overflow-hidden select-none`}>
      {FormatResponse(props)}
    </pre>
  );
};

export default PreformattedTextContainer;
